import { TInvitationNotificationItem } from '../services/jobInvitation'
import { TNotificationItem } from '../types'
import { FILTER_TYPE, NOTIFY_ACTION } from './action'
import { mapJobInvitationNotificationReducer } from './childReducers/mapJobInvitationNotifications'
import { TAppState, TAction } from './types'

export const notificationReducer = (state: TAppState, action: TAction): TAppState => {
    const { type, payload } = action

    switch (type) {
        case NOTIFY_ACTION.SHOW: {
            return { ...state, isOpen: true }
        }
        case NOTIFY_ACTION.HIDE: {
            return { ...state, isOpen: false }
        }
        case NOTIFY_ACTION.SET_NOTIFY_COUNT: {
            const countPayload = payload as {
                value: number
                type: 'notify' | 'notifyBell'
            }
            const notifyCount =
                countPayload.type === 'notify'
                    ? { notificationCount: countPayload.value }
                    : { notificationBellCount: countPayload.value }

            return { ...state, ...notifyCount }
        }
        case NOTIFY_ACTION.SET_LOADING: {
            return { ...state, isLoading: payload as boolean }
        }
        case NOTIFY_ACTION.SET_NOTIFICATIONS: {
            return { ...state, notifications: payload as TNotificationItem[], isLoading: false }
        }
        case NOTIFY_ACTION.SET_FILTER: {
            return { ...state, filter: payload as FILTER_TYPE }
        }
        case NOTIFY_ACTION.SET_NOTIFY_READ: {
            const notifyKey = payload as string
            // Deep-clone notifications list first
            const newNotifications: TNotificationItem[] = JSON.parse(JSON.stringify(state.notifications))
            const indexKey = newNotifications.findIndex((item) => item.notifyKey === notifyKey)
            if (indexKey < 0) {
                return { ...state }
            }
            newNotifications[indexKey].isRead = 1
            // Set back to state
            return { ...state, notifications: newNotifications }
        }
        case NOTIFY_ACTION.PUSH_TO_NOTIFICATIONS: {
            const newNotifications: TNotificationItem[] = JSON.parse(JSON.stringify(state.notifications))
            // Push to first index of notifications
            newNotifications.unshift(payload as TNotificationItem)

            return { ...state, notifications: newNotifications }
        }
        case NOTIFY_ACTION.MAP_JOB_INVITATION_NOTIFICATIONS: {
            const jobInvitations = payload as TInvitationNotificationItem[]
            // Using child reducer
            return mapJobInvitationNotificationReducer({
                state,
                jobInvitations
            })
        }
        case NOTIFY_ACTION.SET_READ_JOB_INVITATION: {
            const jobInvitationId = payload as number
            let newNotifications: TNotificationItem[] = JSON.parse(JSON.stringify(state.jobInvitationNotifications))

            newNotifications = newNotifications.map((notify) => {
                if (notify.jobInvitationId && notify.jobInvitationId === jobInvitationId) {
                    notify.isRead = 1
                }
                return notify
            })

            return { ...state, jobInvitationNotifications: newNotifications }
        }
        default:
            console.error('Unknown type of Reducer')
            return { ...state }
    }
}
